/**
 * For polyfills not yet introduced to `@babel/polyfill`
 */

import flat from './flat';
import contains from './contains';



// WEBPACK FOOTER //
// ./resources/components/polyfills/index.js